import React from 'react';
import { Field } from 'formik';
import Typeahead from '../../../../modules/Typeahead/Typeahead';
import { localise } from '../../../../../services/lang/lang';
import useAssignInspectorsFormField from './useAssignInspectorsFormField';
export const AssignInspectorFormFieldInput = ({ hasErrors, assignedInspector, onChange, }) => {
    const { onSearch, inspectorSearchResults, isFetching, isFetched, onAdd } = useAssignInspectorsFormField(onChange, assignedInspector);
    return (React.createElement(Field, { fieldId: "inspector_ids", "data-testid": "assign_inspector__form-field", hasError: hasErrors, name: "assignee", as: Typeahead, placeholder: localise('SEARCH_INSPECTORS_PLACEHOLDER'), onChange: (e) => {
            onSearch(e.target.value);
        }, searchResults: inspectorSearchResults, onSelectResult: onAdd, variant: "filled", width: "100%", isDisabled: !!assignedInspector, isFetching: isFetching, isFetched: isFetched }));
};
